module.exports = __webpack_public_path__ + "static/media/fixed-voice-info.fa0efeca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed-voice-info.svg
// module id = 978
// module chunks = 0